import { ViewSupport49Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport49Container"
export function ViewSupport49Page() {
    return (
        <ViewSupport49Container />
    )
}